import { emit, emitter, EmitterEvent } from '@store/events';
import ky from 'ky';

export function addBasketAddProductHandler() {
  emitter.on(EmitterEvent.BasketReload, async (widgetUrl: string) => {
    const response = await ky.get(widgetUrl);
    if (response.ok) {
      const html = await response.text();
      const widgetElement = document.getElementById('shopping-basket-widget');
      if (widgetElement) {
        widgetElement.innerHTML = html;
      }
    }
  });

  emitter.on(EmitterEvent.BasketProductChanged, (data: Record<string, unknown>) => {
    if (!window.dataLayer) return;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(data);

    // if (Object.prototype.hasOwnProperty.call(window, 'dataLayer')) {
    //   const w: Window & { dataLayer: unknown[] } = window;
    //   w.dataLayer.push({ ecommerce: null });
    //   w.dataLayer.push(data);
    // }
  });

  document.addEventListener('submit', async event => {
    const target = event.target as HTMLFormElement;
    if (!target.matches('[data-id="addToBasket"]')) return;

    event.preventDefault();

    const fd = new FormData(target);

    const response = await ky.post(target.action, {
      body: fd,
      throwHttpErrors: false,
    });

    if (response.ok) {
      const json = await response.json<object>();
      if ('notification' in json && json.notification) emit.alert(json.notification);
      if ('widgetUrl' in json && json.widgetUrl) emit.basket.reload(json.widgetUrl);
      if ('analyticsEvent' in json && json.analyticsEvent)
        emit.basket.productChanged(json.analyticsEvent);
    }
  });
}
